import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AccountPage } from '../pages/account';
import { DashboardLayout } from 'src/layouts/dashboard/layout';
import { AuthGuard } from '@onesource/components';

export const Route = createFileRoute('/account')({
  validateSearch: z.object({
    tab: z.enum(['profile', 'programs', 'security', 'teachers-directory']).optional().catch(undefined),
  }),
  component: () => (
    <DashboardLayout>
      <AuthGuard>
        <AccountPage />
      </AuthGuard>
    </DashboardLayout>
  ),
});
